import {createStore, applyMiddleware} from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import {logger} from 'redux-logger';
import thunk from 'redux-thunk';

import rootReducer from './reducers';

function configureStore(disableLog) {
  let store;

  if (disableLog) {
    store = createStore(rootReducer, applyMiddleware(thunk));
  } else {
    store = createStore(rootReducer, applyMiddleware(thunk, logger, reduxImmutableStateInvariant()));
  }

  return store;
}

export default configureStore;

// #region Redux Toolkit
// import {logger} from 'redux-logger';
// import {configureStore} from '@reduxjs/toolkit';
// import rootReducer from './reducers';
// import serializableCheckStore from './serializableCheckStore';

// function configureStore(disableLog) {
//   let store;

//   if (disableLog) {
//     store = configureStore({reducer: rootReducer});
//   } else {
//     store = configureStore({
//       reducer: rootReducer,
//       middleware: (getDefaultMiddleware) =>
//         getDefaultMiddleware({serializableCheck: serializableCheckStore}).concat(logger),
//     });
//   }

//   return store;
// }

// export default configureStore;
// #endregion
